{
  "zh-CN": {
    "messages": {
      "copy": {
        "success": "文本已复制！",
        "failure": "无法复制文本"
      },
      "copyGitRevision": {
        "success": "Git 版本已复制！",
        "failure": "无法复制 Git 版本"
      },
      "copyImageUrl": {
        "success": "图片链接已复制！",
        "failure": "无法复制图片链接"
      },
      "copyVideoUrl": {
        "success": "视频链接已复制！",
        "failure": "无法复制视频链接"
      },
      "copyShareUrl": {
        "success": "链接 \"%{url}\" 已复制！",
        "failure": "无法复制链接"
      },
      "copyInviteUrl": {
        "success": "邀请链接 \"%{url}\" 已复制！",
        "failure": "无法复制邀请链接"
      },
      "copyTwoFactorProvisioningUrl": {
        "success": "配置链接已复制！",
        "failure": "无法复制配置链接"
      },
      "copyBackupCodes": {
        "success": "备份代码已复制！",
        "failure": "无法复制备份代码"
      },
      "signup": {
        "success": "<b>欢迎来到 FleetYards.net！</b> 你的账户已创建。 <br>你将收到一封确认邮件来激活你的账户。",
        "invalid": "请在创建账户之前解决错误。",
        "failure": "我们无法创建你的账户。请稍后再试。"
      },
      "accountConfirm": {
        "success": "你的账户已成功确认。<br>现在你可以登录了。",
        "failure": "你的账户无法确认。"
      },
      "requestPasswordChange": {
        "success": "如果您的邮箱地址存在于我们的数据库中，您将在几分钟内收到密码恢复链接。"
      },
      "changePassword": {
        "success": "您的密码已成功更改。",
        "failure": "无法更新您的密码。"
      },
      "updateProfile": {
        "success": "资料已更新。",
        "failure": "无法更新资料。"
      },
      "updateHangar": {
        "success": "机库设置已更新。"
      },
      "updatePrivacy": {
        "success": "隐私设置已更新。"
      },
      "features": {
        "updated": "功能已更新。",
        "error": "无法更新功能。",
        "actorAdded": "角色已添加到功能。",
        "actorRemoved": "角色已从功能中移除。",
        "groupAdded": "群组已添加到功能。",
        "groupRemoved": "群组已从功能中移除。",
        "created": "功能已创建。",
        "destroyed": "功能已移除。",
        "createError": "无法创建功能。"
      },
      "rsiRequestLogs": {
        "resolved": "请求日志已标记为已解决。",
        "error": "无法更新请求日志。"
      },
      "updateNotifications": {
        "success": "通知设置已更新。",
        "failure": "无法保存您的通知设置。"
      },
      "updateAccount": {
        "success": "账户已更新。"
      },
      "oauthApplications": {
        "create": {
          "success": "OAuth 应用已创建。",
          "error": "无法创建 OAuth 应用。"
        },
        "update": {
          "success": "OAuth 应用已更新。",
          "error": "无法更新 OAuth 应用。"
        },
        "destroy": {
          "success": "OAuth 应用已删除。",
          "error": "无法删除 OAuth 应用。"
        },
        "regenerateSecret": {
          "success": "客户端密钥已重新生成。",
          "error": "无法重新生成客户端密钥。"
        },
        "copied": "已复制到剪贴板。",
        "copyError": "无法复制到剪贴板。",
        "secretWarning": "请立即复制客户端密钥。您将无法再次查看。"
      },
      "avatarUpload": {
        "create": {
          "success": "头像已上传",
          "failure": "无法上传头像"
        },
        "destroy": {
          "success": "头像已移除",
          "failure": "无法移除头像"
        },
        "invalidExtension": "您提供的图片格式无效。支持的格式：%{extensions}。"
      },
      "hangarImport": {
        "success": "导入完成",
        "partialSuccess": "导入部分完成。<br><br>未找到的飞船：<br>%{missing}",
        "failure": "导入失败",
        "invalidExtension": "您提供的导入文件格式无效。支持的格式：%{extensions}。"
      },
      "hangarExport": {
        "failure": "导出失败，请稍后再试。"
      },
      "vehicle": {
        "add": {
          "success": {
            "noHtml": "您的新 %{model} 将被交付到您的机库",
            "paragraph1": "您的新 ",
            "paragraph2": "将被交付到您的 "
          }
        },
        "addToWishlist": {
          "success": {
            "noHtml": "您的新 %{model} 已添加到您的愿望清单",
            "paragraph2": "已添加到您的 "
          }
        },
        "resetIngame": {
          "moveToWishlist": {
            "success": "已将所有游戏内购买的飞船移动到您的愿望清单。",
            "failure": "无法将所有游戏内购买的飞船移动到您的愿望清单。"
          },
          "removeAll": {
            "success": "已从您的机库中移除所有游戏内购买的飞船。",
            "failure": "无法从您的机库中移除所有游戏内购买的飞船。"
          }
        }
      },
      "model": {
        "onSale": "%{model} 现在特价销售！",
        "syncStarted": "Model sync started. You will be notified when it completes.",
        "syncMatrixStarted": "Model matrix sync started. You will be notified when it completes.",
        "syncScDataStarted": "Model SC data sync started. You will be notified when it completes.",
        "importPaintsStarted": "涂装导入已开始。完成后将通知您。"
      },
      "fundingGoal": {
        "created": "筹款目标已创建。",
        "updated": "筹款目标已更新。",
        "destroyed": "筹款目标已删除。",
        "createFailed": "无法创建筹款目标。",
        "updateFailed": "无法更新筹款目标。"
      },
      "supporterContribution": {
        "created": "支持者捐助已创建。",
        "updated": "支持者捐助已更新。",
        "destroyed": "支持者捐助已删除。",
        "createFailed": "无法创建支持者捐助。",
        "updateFailed": "无法更新支持者捐助。"
      },
      "notification": {
        "granted": "欢迎使用 FleetYards.net 通知！"
      },
      "twoFactor": {
        "enable": {
          "success": "双因素认证已启用！",
          "failure": "无法启用双因素认证。"
        },
        "disable": {
          "success": "双因素认证已禁用！",
          "failure": "无法禁用双因素认证。"
        },
        "backupCodes": {
          "failure": "无法生成备份代码。"
        }
      },
      "error": {
        "usernameTaken": "用户名已被占用。",
        "userNotFound": "用户未找到",
        "urlInvalid": "URL 无效",
        "emailTaken": "邮箱已被占用。",
        "fleetTaken": "舰队名已被占用。",
        "colorInvalid": "颜色无效",
        "serialTaken": "序列号已被占用。",
        "textInvalid": "%{field} 无效",
        "hangar": {
          "accountRequired": {
            "noHtml": "您需要注册或登录以向机库添加飞船。",
            "paragraph1": "您需要 ",
            "paragraph2": " 以向机库添加飞船。",
            "paragraph3": "获取更多信息 "
          }
        },
        "default": "<b>出现了一些问题。</b> <br>您是否尝试过关闭并重新打开？"
      },
      "account": {
        "destroy": {
          "success": "<b>您的账户已被删除。</b> <br>很遗憾看到您离开 :'(",
          "failure": "我们无法删除您的账户！请稍后再试。"
        },
        "calendarSubscription": {
          "enable": {
            "success": "个人日历订阅已启用。",
            "failure": "无法启用日历订阅。"
          },
          "rotate": {
            "success": "个人日历链接已更换。现有订阅者将不再收到更新，直到他们重新订阅。",
            "failure": "无法更换个人日历链接。",
            "confirm": "更换链接会静默地使所有订阅了当前地址的日历应用失效。您需要使用新链接重新订阅。"
          },
          "disable": {
            "success": "个人日历订阅已停用。",
            "failure": "无法停用个人日历订阅。",
            "confirm": "停用订阅会中断当前所有已订阅日历应用的数据源。"
          }
        }
      },
      "user": {
        "destroy": {
          "success": "用户已删除。",
          "failure": "无法删除用户。"
        }
      },
      "fleet": {
        "create": {
          "success": "您的舰队已创建。",
          "failure": "舰队无法保存。"
        },
        "update": {
          "success": "设置已保存。",
          "failure": "设置无法保存。"
        },
        "destroy": {
          "success": "您的舰队已被删除。",
          "failure": "我们无法删除您的舰队。"
        },
        "leave": {
          "success": "您已离开舰队。",
          "failure": "无法离开舰队。"
        },
        "invites": {
          "accept": {
            "success": "邀请已接受。",
            "failure": "无法接受邀请。"
          },
          "decline": {
            "success": "邀请已拒绝。",
            "failure": "无法拒绝邀请。"
          },
          "create": {
            "failure": "无法邀请用户。"
          }
        },
        "members": {
          "update": {
            "success": "设置已保存。",
            "failure": "设置无法保存。"
          },
          "destroy": {
            "success": "成员已移除。",
            "failure": "无法移除成员。"
          },
          "demote": {
            "success": "成员已降级。",
            "failure": "无法降级成员。"
          },
          "promote": {
            "success": "成员已升级。",
            "failure": "无法升级成员。"
          },
          "accept": {
            "success": "成员已接受。",
            "failure": "无法接受成员。"
          },
          "decline": {
            "success": "成员已拒绝。",
            "failure": "无法拒绝成员。"
          }
        },
        "calendarSubscription": {
          "enable": {
            "success": "日历订阅已启用。",
            "failure": "无法启用日历订阅。"
          },
          "rotate": {
            "success": "订阅链接已更换。现有订阅者将不再收到更新，直到他们重新订阅。",
            "failure": "无法更换订阅链接。",
            "confirm": "更换链接会静默地使所有订阅了当前地址的日历应用失效。他们需要使用新链接重新订阅。"
          },
          "disable": {
            "success": "日历订阅已停用。",
            "failure": "无法停用日历订阅。",
            "confirm": "停用订阅会中断当前所有已订阅日历应用的数据源。"
          },
          "copy": {
            "success": "日历链接已复制。请将其粘贴到日历应用的“订阅日历”或“通过 URL 添加”中。",
            "failure": "无法复制日历链接。"
          }
        }
      },
      "fleetInvite": {
        "used": "<b>%{fleet} 的加入请求已发送！</b><br>一旦您的会员资格被接受，您将通过电子邮件收到通知",
        "failure": "邀请无法使用。",
        "notFound": "邀请未找到。",
        "confirm": "您确定要加入舰队：\"%{fleet}\"吗？"
      },
      "holoViewer": {
        "modelLoader": {
          "failure": "我们无法加载请求的3D模型！请稍后再试。"
        },
        "webglNotSupported": "此设备不支持 3D 查看器。"
      },
      "cargoGridViewer": {
        "noCargoHolds": "此飞船没有货舱。",
        "confirmReset": "Are you sure you want to reset all ships and container settings?"
      },
      "confirm": {
        "vehicle": {
          "destroy": "您确定要从机库中移除这艘飞船吗？"
        },
        "hangarGroup": {
          "destroy": "您确定要从机库中移除这个群组吗？"
        },
        "hangar": {
          "import": "导入的飞船将被添加到您的机库中，而不会与现有飞船进行匹配。<br><br>支持的格式：Fleetyards 导出 或 HangarXplor。<br><br>您想继续吗？",
          "destroySelected": "您确定要从机库中移除所有选定的飞船吗？此操作无法撤销。",
          "destroyAll": "您确定要从机库中移除所有飞船吗？此操作无法撤销。"
        },
        "wishlist": {
          "destroyAll": "您确定要从愿望清单中移除所有飞船吗？此操作无法撤销。"
        },
        "account": {
          "destroy": "您确定要删除您的账户吗？此操作无法撤销。",
          "destroyWithFleets": "您是以下舰队的管理员: %{fleets}。删除账户将同时解散这些舰队并移除其所有成员。此操作无法撤销。要继续吗?"
        },
        "itemPrice": {
          "destroy": "Are you sure you want to destroy this Item Price? This Action can't be reverted."
        },
        "fleet": {
          "leave": "您确定要离开舰队吗？此操作无法撤销。",
          "destroy": "您确定要删除您的舰队吗？此操作无法撤销。",
          "members": {
            "destroy": "您确定要移除此成员吗？",
            "remove": "确定要将该成员从舰队中移除吗？"
          },
          "invites": {
            "decline": "您确定要拒绝此邀请吗？此操作无法撤销。"
          }
        },
        "oauthApplication": {
          "destroy": "确定要删除此 OAuth 应用吗? 此操作无法撤销。",
          "regenerateSecret": "确定要重新生成客户端密钥吗? 现有集成将停止工作。"
        },
        "twoFactor": {
          "generateBackupCodes": "您确定要重新生成您的双因素认证备份代码吗？"
        },
        "user": {
          "loginAs": "Are you sure you want to login as this user?",
          "resendConfirmation": "Are you sure you want to resend the confirmation email for this user?",
          "sendPasswordReset": "Are you sure you want to send a password reset email for this user?",
          "destroy": "Are you sure you want to delete this user? This action can't be reverted.",
          "destroyWithFleets": "该用户是以下舰队的管理员: %{fleets}。删除该用户将同时解散这些舰队并移除其所有成员。此操作无法撤销。要继续吗?"
        },
        "model": {
          "destroy": "Are you sure you want to delete this model? This action can't be reverted.",
          "sync": "Are you sure you want to sync this model from RSI?",
          "syncMatrix": "Are you sure you want to sync the ship matrix data for this model?",
          "syncScData": "Are you sure you want to sync the SC data for this model?",
          "importPaints": "确定要从机库数据导入此型号的涂装吗? 如果来源将某个涂装标记为整个系列共用，则会为该系列的每个型号都导入一份。",
          "exchangeStoreImage": "Are you sure you want to replace the store image with the RSI image?",
          "reloadMatrix": "Are you sure you want to reload the models matrix? This will enqueue background jobs.",
          "reloadScData": "Are you sure you want to reload SC data? This will enqueue background jobs.",
          "reloadPaints": "确定要重新加载涂装吗? 这将加入后台任务队列。",
          "reloadModules": "确定要重新加载模块吗? 这将加入后台任务队列。",
          "reloadLoaners": "确定要重新加载借用船吗? 这将加入后台任务队列。"
        },
        "manufacturer": {
          "destroy": "Are you sure you want to delete this manufacturer? This action can't be reverted."
        },
        "fundingGoal": {
          "destroy": "确定要删除此筹款目标吗? 此操作无法撤销。"
        },
        "supporterContribution": {
          "destroy": "确定要删除此支持者捐助吗? 此操作无法撤销。"
        },
        "modelHardpoint": {
          "destroy": "确定要删除此挂载点吗? 此操作无法撤销。"
        },
        "modelPosition": {
          "destroy": "确定要删除此岗位吗? 此操作无法撤销。"
        },
        "modelHardpointLoadout": {
          "destroy": "确定要删除此配置吗? 此操作无法撤销。"
        },
        "modelLoaner": {
          "destroy": "确定要删除此借用船吗? 此操作无法撤销。"
        },
        "modelSnubCraft": {
          "destroy": "确定要删除此舰载小艇吗? 此操作无法撤销。"
        },
        "modelPaint": {
          "destroy": "Are you sure you want to delete this paint? This action can't be reverted."
        },
        "video": {
          "destroy": "Are you sure you want to delete this video? This action can't be reverted."
        },
        "modelModule": {
          "destroy": "Are you sure you want to delete this module? This action can't be reverted.",
          "unlink": "Are you sure you want to unlink this module from the model? The module will still exist but won't be associated with this model."
        },
        "modelUpgrade": {
          "destroy": "Are you sure you want to delete this upgrade? This action can't be reverted.",
          "unlink": "Are you sure you want to unlink this upgrade from the model? The upgrade will still exist but won't be associated with this model."
        },
        "modelModulePackage": {
          "destroy": "Are you sure you want to delete this module package? This action can't be reverted."
        },
        "dock": {
          "destroy": "Are you sure you want to delete this dock? This action can't be reverted."
        },
        "component": {
          "destroy": "Are you sure you want to delete this component? This action can't be reverted."
        },
        "adminFleet": {
          "destroy": "Are you sure you want to delete this fleet? This action can't be reverted."
        },
        "adminNotifications": {
          "destroyAll": "确定要删除所有通知吗? 此操作无法撤销。",
          "destroySelected": {
            "one": "确定要删除所选通知吗? 此操作无法撤销。",
            "other": "确定要删除所选的 %{count} 条通知吗? 此操作无法撤销。"
          }
        },
        "adminDestroyedFleet": {
          "restore": "确定要恢复此舰队吗?",
          "restorePurged": "确定要恢复这个已清除的舰队吗? 恢复只是尽力而为: 角色、图片、邀请链接和舰队载具不会被恢复。"
        },
        "adminUser": {
          "destroy": "Are you sure you want to delete this admin user? This action can't be reverted."
        },
        "image": {
          "destroy": "Are you sure you want to delete this image? This action can't be reverted."
        },
        "adminVehicle": {
          "destroy": "Are you sure you want to delete this vehicle? This action can't be reverted."
        },
        "commodity": {
          "destroy": "Are you sure you want to delete this commodity? This action can't be reverted."
        },
        "equipment": {
          "destroy": "Are you sure you want to delete this equipment? This action can't be reverted."
        },
        "notifications": {
          "destroyAll": "确定要删除所有通知吗? 此操作无法撤销。",
          "destroySelected": {
            "one": "确定要删除所选通知吗? 此操作无法撤销。",
            "other": "确定要删除所选的 %{count} 条通知吗? 此操作无法撤销。"
          }
        },
        "unlistedModel": {
          "createModel": "根据 %{name} 创建飞船？下次 sc_data 载入会补齐其数据。"
        }
      },
      "oauthAuthorize": {
        "loading": "加载中...",
        "loadError": "加载授权详情失败。",
        "authorizeError": "授权失败。",
        "denyError": "授权拒绝失败。"
      },
      "oauth": {
        "disconnect": {
          "success": "服务商已成功断开。",
          "failure": "无法断开服务商。请重试。"
        }
      },
      "confirmAccess": {
        "failure": "无法确认访问。请检查密码并重试。"
      },
      "setEmail": {
        "success": "确认邮件已发送到您的新邮箱地址，请检查收件箱。",
        "failure": "无法更新电子邮件地址，请重试。"
      },
      "confirmAccessEmail": {
        "sent": "确认码已发送到您的电子邮件。",
        "failure": "无法发送确认邮件。请重试。"
      },
      "confirmAccessCode": {
        "failure": "确认码无效或已过期。"
      },
      "import": {
        "started": "%{type} 导入已开始...",
        "finished": "%{type} 导入成功完成。",
        "failed": "%{type} 导入失败: %{info}"
      },
      "syncExtension": {
        "started": "正在同步您的机库...",
        "success": "您的机库已同步。",
        "failure": "您的机库无法同步。",
        "notLoggedIn": "您需要登录 <a href=\"https://robertsspaceindustries.com\" target=\"_blank\">https://robertsspaceindustries.com</a> 以同步您的机库。"
      },
      "admin": {
        "supporterContributions": {
          "patreonSyncStarted": "Patreon 同步已开始。请稍后刷新以查看导入的支持者。"
        }
      },
      "logistics": {
        "request": {
          "create": {
            "success": "Logistics request created.",
            "failure": "Could not create logistics request."
          }
        },
        "inventory": {
          "create": {
            "success": "Inventory created.",
            "failure": "Could not create inventory."
          },
          "update": {
            "success": "Inventory updated.",
            "failure": "Could not update inventory."
          },
          "destroy": {
            "success": "Inventory deleted.",
            "failure": "Could not delete inventory."
          }
        },
        "inventoryItem": {
          "create": {
            "success": "Item added to inventory.",
            "failure": "Could not add item to inventory."
          },
          "deposit": {
            "success": "Deposit recorded.",
            "failure": "Could not record deposit."
          },
          "withdrawal": {
            "success": "Withdrawal recorded.",
            "failure": "Could not record withdrawal. Check available stock."
          },
          "destroy": {
            "success": "Entry deleted.",
            "failure": "Could not delete entry.",
            "confirm": "Delete this entry? The stock it added or removed is corrected accordingly."
          }
        },
        "comment": {
          "create": {
            "success": "Comment added.",
            "failure": "Could not add comment."
          }
        },
        "csvImport": {
          "success": "%{count} items imported successfully.",
          "failure": "Could not import CSV file."
        },
        "stockItem": {
          "update": {
            "success": "Item updated.",
            "failure": "Could not update item."
          },
          "destroy": {
            "success": "Item deleted.",
            "failure": "Could not delete item.",
            "confirm": "Delete this item and all %{count} of its entries? This cannot be undone.",
            "confirmAll": "删除该物品及其所有记录？此操作无法撤销。"
          }
        },
        "vehicleInventory": {
          "clear": {
            "confirm": "清空这艘飞船的货物？所有记录都会被删除。",
            "success": "货物已清空。",
            "failure": "无法清空货物。"
          }
        }
      },
      "adminNotifications": {
        "unread": "通知已标记为未读",
        "archived": "通知已归档",
        "unarchived": "通知已移回收件箱",
        "readAll": "所有通知已标记为已读",
        "destroyed": "通知已删除",
        "destroyedAll": "所有通知已删除",
        "error": "出错了",
        "bulk": {
          "read": {
            "one": "%{count} 条通知已标记为已读",
            "other": "%{count} 条通知已标记为已读"
          },
          "unread": {
            "one": "%{count} 条通知已标记为未读",
            "other": "%{count} 条通知已标记为未读"
          },
          "archived": {
            "one": "%{count} 条通知已归档",
            "other": "%{count} 条通知已归档"
          },
          "unarchived": {
            "one": "%{count} 条通知已移回收件箱",
            "other": "%{count} 条通知已移回收件箱"
          },
          "destroyed": {
            "one": "%{count} 条通知已删除",
            "other": "%{count} 条通知已删除"
          }
        }
      },
      "fleets": {
        "notifications": {
          "update": {
            "success": "通知设置已保存。",
            "failure": "无法保存通知设置。"
          }
        },
        "mission": {
          "create": {
            "success": "任务已创建。",
            "failure": "无法创建任务。"
          },
          "update": {
            "success": "任务已更新。",
            "failure": "无法更新任务。"
          },
          "archive": {
            "success": "任务已归档。",
            "failure": "无法归档任务。"
          },
          "unarchive": {
            "success": "任务已恢复。",
            "failure": "无法恢复任务。"
          },
          "destroy": {
            "success": "任务已删除。",
            "failure": "无法删除任务。",
            "confirm": "这将永久删除该任务及其所有小队、飞船和席位。此操作无法撤销。"
          }
        },
        "missionTeam": {
          "create": {
            "success": "小队已添加。",
            "failure": "无法添加小队。"
          },
          "update": {
            "success": "小队已更新。",
            "failure": "无法更新小队。"
          },
          "destroy": {
            "success": "小队已移除。",
            "failure": "无法移除小队。"
          }
        },
        "missionShip": {
          "create": {
            "success": "飞船已添加。",
            "failure": "无法添加飞船。"
          },
          "update": {
            "success": "飞船已更新。",
            "failure": "无法更新飞船。"
          },
          "destroy": {
            "success": "飞船已移除。",
            "failure": "无法移除飞船。"
          },
          "duplicate": {
            "success": "飞船已复制。",
            "failure": "无法复制该飞船。"
          }
        },
        "missionSlot": {
          "create": {
            "success": "席位已添加。",
            "failure": "无法添加席位。"
          },
          "update": {
            "success": "席位已更新。",
            "failure": "无法更新席位。"
          },
          "destroy": {
            "success": "席位已移除。",
            "failure": "无法移除席位。"
          }
        },
        "event": {
          "create": {
            "success": "活动已创建。",
            "failure": "无法创建活动。"
          },
          "update": {
            "success": "活动已更新。",
            "failure": "无法更新活动。"
          },
          "archive": {
            "success": "活动已归档。",
            "failure": "无法归档活动。",
            "confirm": "要归档此活动吗? 成员将不会再在近期活动列表中看到它。"
          },
          "unarchive": {
            "success": "活动已从归档中恢复。",
            "failure": "无法恢复活动。"
          },
          "syncToDiscord": {
            "success": "活动已推送到 Discord。",
            "failure": "无法将活动推送到 Discord。"
          },
          "destroy": {
            "success": "活动已删除。",
            "failure": "无法删除活动。",
            "confirm": "这将永久删除该活动。此操作无法撤销。"
          },
          "publish": {
            "success": "活动已发布 — 报名现已开放。",
            "failure": "无法发布活动。"
          },
          "lockSignups": {
            "success": "报名已锁定。",
            "failure": "无法锁定报名。"
          },
          "unlockSignups": {
            "success": "报名已重新开放。",
            "failure": "无法重新开放报名。"
          },
          "start": {
            "success": "活动已开始。",
            "failure": "无法开始活动。"
          },
          "complete": {
            "success": "活动已标记为已完成。",
            "failure": "无法完成活动。"
          },
          "cancel": {
            "success": "活动已取消。",
            "failure": "无法取消活动。",
            "confirm": "要取消此活动吗? 参与者将收到通知。"
          }
        },
        "eventSignup": {
          "create": {
            "success": "您已报名。",
            "failure": "无法报名。"
          },
          "update": {
            "success": "报名已更新。",
            "failure": "无法更新报名。"
          },
          "withdraw": {
            "success": "您已退出该活动。",
            "failure": "无法取消报名。",
            "confirm": "要退出此活动吗?"
          },
          "kick": {
            "success": "报名已移除。",
            "failure": "无法移除报名。",
            "confirm": "要移除该成员的报名吗?"
          }
        },
        "eventAdmin": {
          "create": {
            "success": "角色已授予。",
            "failure": "无法授予角色。"
          },
          "destroy": {
            "success": "角色已撤销。",
            "failure": "无法撤销角色。",
            "confirm": "要撤销 %{username} 在此活动中的角色吗?"
          }
        },
        "eventTeam": {
          "create": {
            "success": "小队已添加。",
            "failure": "无法添加小队。"
          },
          "update": {
            "success": "小队已更新。",
            "failure": "无法更新小队。"
          },
          "destroy": {
            "success": "小队已移除。",
            "failure": "无法移除小队。",
            "confirm": "要移除该小队及其所有飞船和席位吗?"
          }
        },
        "eventShip": {
          "create": {
            "success": "飞船已添加。",
            "failure": "无法添加飞船。"
          },
          "update": {
            "success": "飞船已更新。",
            "failure": "无法更新飞船。"
          },
          "destroy": {
            "success": "飞船已移除。",
            "failure": "无法移除飞船。",
            "confirm": "要移除该飞船及其席位吗?"
          },
          "expand": {
            "success": "席位已添加。",
            "failure": "无法添加席位。"
          }
        },
        "eventSlot": {
          "create": {
            "success": "席位已添加。",
            "failure": "无法添加席位。"
          },
          "update": {
            "success": "席位已更新。",
            "failure": "无法更新席位。"
          },
          "destroy": {
            "success": "席位已移除。",
            "failure": "无法移除席位。"
          }
        }
      },
      "notifications": {
        "unread": "通知已标记为未读",
        "archived": "通知已归档",
        "unarchived": "通知已移回收件箱",
        "readAll": "所有通知已标记为已读",
        "destroyed": "通知已删除",
        "destroyedAll": "所有通知已删除",
        "actionDone": "完成",
        "actionFailed": "操作未成功 - 该通知可能已过期",
        "error": "出错了",
        "bulk": {
          "read": {
            "one": "%{count} 条通知已标记为已读",
            "other": "%{count} 条通知已标记为已读"
          },
          "unread": {
            "one": "%{count} 条通知已标记为未读",
            "other": "%{count} 条通知已标记为未读"
          },
          "archived": {
            "one": "%{count} 条通知已归档",
            "other": "%{count} 条通知已归档"
          },
          "unarchived": {
            "one": "%{count} 条通知已移回收件箱",
            "other": "%{count} 条通知已移回收件箱"
          },
          "destroyed": {
            "one": "%{count} 条通知已删除",
            "other": "%{count} 条通知已删除"
          }
        }
      }
    }
  }
}
